// NOTE: hooks
import { useAuthContext } from './useAuthContext'
import { PERMISSIONS } from '../utils/permissions'

const resolveUserRole = (user: any) => {
  if (!user) return 'regularUser'

  const isManager = user.team?.managers?.includes(user.email)

  if ((user.admin === 1 || user.clinician === 1000) && !isManager) return 'clinicSystemAdmin'

  if ((user.admin === 1 || user.clinician >= 100) && isManager) return 'clinicAdmin'

  if (isManager && user.clinician === 0) return 'manager'

  // NOTE: a specialist reaches their patients through their clinic or their investigations, not through managing a team
  if (user.clinician === 1) return 'specialist'

  return 'regularUser'
}

const usePermission = () => {
  const { user } = useAuthContext()

  const role = resolveUserRole(user)
  const permissions = PERMISSIONS[role] || PERMISSIONS['regularUser']

  const canView = (page: string): boolean => {
    return (
      permissions.canView.includes('*') ||
      permissions.canView.includes(page)
    )
  }

  const canWrite = (page: string): boolean => {
    return (
      permissions.canWrite.includes('*') ||
      permissions.canWrite.includes(page)
    )
  }

  const isRestricted = (page: string): boolean => {
    const restricted = 'restricted' in permissions ? permissions.restricted : []
    return restricted.includes(page)
  }

  return {
    role,
    canView,
    canWrite,
    isRestricted,
    user,
  }
}

export { usePermission }

